export default function buildInitialValues(obj, properties) {
    return properties.reduce((obj2, key) => Object.assign(obj2, { [key]: (obj ? obj[key] === false ? false : obj[key] : null) || '' }), {});
}
